import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3, 3, 6, 3),
  },
  cardContent: {
   width: '100%'
  },
  aboutProject: {
    marginTop: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(2),
    width: '100%'
  },
  item: {
    padding: theme.spacing(1),
  },
  botoesFormulario: {
    marginTop: theme.spacing(2),
  },
  tituloCampo: {
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
    fontSize: '18px',
  },
  grupoEspelho: {
    padding: theme.spacing(2),
  },
  dadoEspelho: {
    fontSize: '13px',
  },
  dividerTitle: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  anuncio: {
    borderRadius: '6px',
    borderBottom: 'thin solid #DDD',
    background: '#E4E6E8',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  text: {
    color: '#000000',
  },
  detalhes: {
    display: 'flex',
    justifyContent: 'end',
    borderTop: '3px solid #FFF',
    alignItems: 'center',
    alignContent: 'center',
  },
  detalhesBtn: {
    marginTop: '10px',
  },
  cadastrarBtn: {
    display: 'flex',
    justifyContent: 'end',
    marginBottom: '10px',
  }
}))

export default useStyles